import {getProductStock, getProductStockForBatch, Nullable, Product, ProductBatch} from "@framework/types";
import {getPriceForProduct} from "@framework/product/use-price";

export interface CartItem {
  id: string | number;
  batch_id?: Nullable<string|number>;
  name?: string;
  name_de: string,
  name_en: string,
  name_fr: string,
  name_he: string,
  slug: string;
  image: Nullable<string>;
  price: number;
  sale_price?: number;
  quantity?: number;
  stock: number;
  [key: string]: unknown;
}

export function generateCartItem(item: Product, batch: Nullable<ProductBatch>): CartItem {
  if (batch) {
    const price = getPriceForProduct(item, batch)
    return {
      id: item.id,
      batch_id: batch.batch_id,
      productId: item.id,
      name_de: `${item.name_de} - ${batch.expiration_date}`,
      name_en: `${item.name_en} - ${batch.expiration_date}`,
      name_fr: `${item.name_fr} - ${batch.expiration_date}`,
      name_he: `${item.name_he} - ${batch.expiration_date}`,
      slug: item.slug,
      unit: item.unit,
      stock: getProductStockForBatch(item, batch),
      price: price * item.items_per_unit,
      image: item.image,
      variationId: batch.batch_id,
    };
  }
  return {
    id: item.id,
    name_de: item.name_de,
    name_en: item.name_en,
    name_fr: item.name_fr,
    name_he: item.name_de,
    slug: item.slug,
    unit: item.unit,
    image: item.image,
    stock: getProductStock(item),
    price: (item.sale_price ? item.sale_price : item.price) * item.items_per_unit,
  };
}
